/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 17:51:46
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-25 11:40:44
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/Filter/Cascader/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import { Cascader } from 'src/components/Antd';
import Trigger from '../DropDown/Trigger';

const _Cascader = (props) => {
  const { keyWord, options, value = [], onConfirm, dropdownProps } = props;
  const { name } = dropdownProps || {};
  const handleOnConfirm = (key, selectedOptions) => {
    if (onConfirm) {
      onConfirm({
        [keyWord]: selectedOptions.map((i) => ({
          value: i.value,
          label: i.label,
        })),
      });
    }
  };

  return (
    <Cascader
      // popupVisible={true}
      //expandTrigger='hover'
      popupClassName={css.filterDropdownContainer}
      value={value}
      options={options}
      onChange={handleOnConfirm}>
      <div>
        <Trigger name={name} className={css.trigger} />{' '}
      </div>
      {/* */}
    </Cascader>
  );
};

export default _Cascader;
